import { Action } from '../actions/home';

const defaultState = {
  isFetching: false,
  error: undefined,
  cards: undefined,
};

export default function homeReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Home.FetchHomeScreenCardsPending:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };

    case Action.Home.FetchHomeScreenCardsCompleted:
      return {
        ...state,
        isFetching: false,
        cards: body.cards,
      };

    case Action.Home.FetchHomeScreenCardsFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    default:
      return state;
  }
}
